export default __webpack_public_path__ + "static/media/barra.5be93abd.png";